import { render, staticRenderFns } from "./VisualDisclaimer.vue?vue&type=template&id=a00f85ce&scoped=true&"
import script from "./VisualDisclaimer.vue?vue&type=script&lang=js&"
export * from "./VisualDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./VisualDisclaimer.vue?vue&type=style&index=0&id=a00f85ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00f85ce",
  null
  
)

export default component.exports